'use strict';
import notificationApiWrapper from './notificationApiWrapper';

const notifications = [
    [require('./rules/tradeLoyaltyPromptRule'), 'tradeLoyaltyPromptRule', 445],
    [
        require('./rules/pinterestConnectAccountsModalRule'),
        'pinterestConnectAccountsModalRule',
        440,
    ],
    [require('./rules/tradeTourRule'), 'tradeTourRule', 435],
    [require('./rules/netPriceRule'), 'netPriceRule', 430],
    [require('./rules/requestItemHoldRule'), 'requestItemHoldRule', 425],
    [
        require('./rules/multiplePdpVisitsRule.es').multiplePdpVisitsModalRule,
        'multiplePdpVisitsRule',
        345,
    ],
    [require('./rules/saveItemCalloutRule'), 'saveItemCalloutRule', 245],
    [require('./rules/followSearchCalloutRule'), 'followSearchCalloutRule', 240],
    [require('./rules/viewInvoiceCalloutRule'), 'viewInvoiceCalloutRule', 235],
    [require('./rules/saveToFolderCalloutRule'), 'saveToFolderCalloutRule', 230],
    // require('./rules/chatRule'),
    [require('./rules/followDealerCalloutRule'), 'followDealerCalloutRule', 220],
    [
        require('./rules/favoritesCalloutsRules').default.rearrangeItemsRule,
        'rearrangeItemsRule',
        95,
    ],
    [require('./rules/favoritesCalloutsRules').default.editFolderRule, 'editFolderRule', 90],
    /*
    * This callout should be moved to dibs-buyer-layout as it currently won't appear in .com anyway.
    */
    //require('./rules/searchBoxCalloutRule')
];

// wrap all the old notifications so the new queue can use them
module.exports = context => {
    return notifications.map(notificationApiWrapper.bind(this, context)); // pass context to each notification
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/notificationHelper.es.js